import { render, staticRenderFns } from "./MallShop.vue?vue&type=template&id=d914fabc&scoped=true&"
import script from "./MallShop.vue?vue&type=script&lang=js&"
export * from "./MallShop.vue?vue&type=script&lang=js&"
import style0 from "./MallShop.vue?vue&type=style&index=0&id=d914fabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d914fabc",
  null
  
)

export default component.exports